const NOTIFICATION_TYPES = {
  PROCESS: 1,
  TASK: 2,
  KNOWLEDGE: 4,
  POST: 8,
  JOB: 16,
  ACTION: 32,
  TRAINING: 64,
  ACCREDITATION: 128,
}

export { NOTIFICATION_TYPES }
